// Useful for ensuring switch exhaustiveness as described here:
// https://www.typescriptlang.org/docs/handbook/advanced-types.html#exhaustiveness-checking
export function assertNever(x, message) {
    throw new Error(message ?? 'Unexpected object: ' + x);
}
